/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { replace as e } from "../../core/string.js";
var n = "__begin__",
    r = "__end__",
    s = new RegExp(n, "ig"),
    t = new RegExp(r, "ig"),
    o = new RegExp("^" + n, "i"),
    i = new RegExp(r + "$", "i"),
    l = '"',
    a = l + " + ",
    c = " + " + l;

function p(e) {
  return e.replace(new RegExp("\\[", "g"), "{").replace(new RegExp("\\]", "g"), "}");
}

function u(e) {
  return e.replace(new RegExp("\\{", "g"), "[").replace(new RegExp("\\}", "g"), "]");
}

function x(e) {
  var n = {
    expression: "",
    type: "none"
  };
  return e.labelExpressionInfo ? e.labelExpressionInfo.value ? (n.expression = e.labelExpressionInfo.value, n.type = "conventional") : e.labelExpressionInfo.expression && (n.expression = e.labelExpressionInfo.expression, n.type = "arcade") : null != e.labelExpression && (n.expression = p(e.labelExpression), n.type = "conventional"), n;
}

function f(e) {
  var n = x(e);
  if (!n) return null;

  switch (n.type) {
    case "conventional":
      return w(n.expression);

    case "arcade":
      return n.expression;
  }

  return null;
}

function g(e) {
  var n = x(e);
  if (!n) return null;

  switch (n.type) {
    case "conventional":
      return $(n.expression);

    case "arcade":
      return _(n.expression);
  }

  return null;
}

function w(p) {
  var u;
  return p ? (u = e(p, function (e) {
    return n + '$feature["' + e + '"]' + r;
  }), u = o.test(u) ? u.replace(o, "") : l + u, u = i.test(u) ? u.replace(i, "") : u + l, u = u.replace(s, a).replace(t, c)) : u = '""', u;
}

var E = /^\s*\{([^}]+)\}\s*$/i;

function $(e) {
  var n = e.match(E);
  return n && n[1].trim() || null;
}

var b = /^\s*(?:(?:\$feature\.(\w+))|(?:\$feature\[(["'])([\w\s]+)(\2)\]));?\s*$/i,
    m = /^\s*(?:(?:\$feature\.(\w+))|(?:\$feature\[(["'])([\w\s]+)(\2)\]));?\s*(?:DomainName\(\s*\$feature\s*,\s*(["'])(\1|\3)(\5)\s*\));?\s*$/i,
    R = /^\s*(?:DomainName\(\s*\$feature\s*,\s*(["'])([\w\s]+)(\1)\s*\));?\s*$/i;

function _(e) {
  if (!e) return null;
  var n = b.exec(e) || m.exec(e);
  return n ? n[1] || n[3] : (n = R.exec(e), n ? n[2] : null);
}

export { w as convertTemplatedStringToArcade, x as getLabelExpression, f as getLabelExpressionArcade, g as getLabelExpressionSingleField, _ as getSingleFieldArcadeExpression, $ as getSingleFieldTemplatedString, p as sqlToTemplateString, u as templateStringToSql };